import styled from '@emotion/styled';
import React, { useState } from 'react';
import { BsFillPlusSquareFill } from 'react-icons/bs';
import { ToolTip } from '../../../_elements/ToolTip';
import { MdTraffic, MdDirectionsBus, MdClose } from 'react-icons/md';
import { FaMapMarkerAlt, FaRegCalendarAlt, FaRobot, FaRoute } from 'react-icons/fa';
import ComponentErrorBoundary from '@/Layouts/ComponentErrorBoundary';

export const StyledCreateChannelToggle = styled.div`
    position: absolute;
    bottom: 6%;
    right: 6%;
    width: 50px;
    height: 50px;
    border-radius: 1000px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: transform 250ms;
    background-color: #50aeb0;
    z-index: 1000;
    :hover {
        transform: scale(1.1);
    }
    &.active {
        transform: scale(1.2);
        background-color: #24637f;
    }
    svg {
        transition: transform 250ms 200ms;
    }
    .rotate {
        svg {
            transform: rotate(45deg);
        }
    }
`;

const FabMenuContainer = styled.div`
    position: absolute;
    bottom: 6%;
    right: 80px;
    z-index: 999;
`;

const FabMenu = styled.div`
    position: absolute;
    bottom: 60px;
    right: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 10px;
    opacity: ${(props) => (props.isOpen ? 1 : 0)};
    transform: ${(props) => (props.isOpen ? 'translateY(0)' : 'translateY(20px)')};
    pointer-events: ${(props) => (props.isOpen ? 'auto' : 'none')};
    transition:
        opacity 0.3s ease,
        transform 0.3s ease;
`;

const FabMenuItem = styled.div`
    display: flex;
    align-items: center;
    background-color: white;
    border-radius: 20px;
    padding: 8px 16px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
    cursor: pointer;
    transition: transform 0.2s ease;
    margin-right: 5px;

    &:hover {
        transform: scale(1.05);
    }

    &.active {
        background-color: #24637f;
        color: white;
    }

    .menu-icon {
        margin-right: 8px;
        font-size: 20px;
    }

    .menu-text {
        font-size: 14px;
        white-space: nowrap;
    }
`;

const Backdrop = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.1);
    z-index: 998;
    display: ${(props) => (props.isOpen ? 'block' : 'none')};
`;

function Component({
    isChannelCreateSelected,
    handleToggleChannelCreate,
    // Overlay toggle props
    showTraffic = false,
    showTransit = false,
    showEventRoutes = false,
    showBobChat = false,
    showCreateEvent = false,
    toggleTraffic = () => {},
    toggleTransit = () => {},
    toggleEventRoutes = () => {},
    toggleCreateEvent = () => {},
    toggleBobChat = () => {},
}) {
    const [menuOpen, setMenuOpen] = useState(false);

    const toggleMenu = (e) => {
        e.stopPropagation();
        setMenuOpen(!menuOpen);
    };

    const closeMenu = () => {
        setMenuOpen(false);
    };

    const handleChannelToggle = (e) => {
        e.stopPropagation();
        handleToggleChannelCreate();
        closeMenu();
    };

    const handleTrafficToggle = (e) => {
        e.stopPropagation();
        toggleTraffic();
        closeMenu();
    };

    const handleTransitToggle = (e) => {
        e.stopPropagation();
        toggleTransit();
        closeMenu();
    };

    const handleEventRoutesToggle = (e) => {
        e.stopPropagation();
        toggleEventRoutes();
        closeMenu();
    };

    const handleCreateEventToggle = (e) => {
        e.stopPropagation();
        toggleCreateEvent();
        closeMenu();
    };
    const handleToggleBobChat = (e) => {
        e.stopPropagation();
        toggleBobChat();
        closeMenu();
    };

    return (
        <>
            <Backdrop isOpen={menuOpen} onClick={closeMenu} />
            <FabMenuContainer>
                <FabMenu isOpen={menuOpen}>
                    <FabMenuItem className={isChannelCreateSelected ? 'active' : ''} onClick={handleChannelToggle}>
                        <FaMapMarkerAlt className="menu-icon" />
                        <span className="menu-text">Create Channel</span>
                    </FabMenuItem>
                    <FabMenuItem className={showCreateEvent ? 'active' : ''} onClick={handleCreateEventToggle}>
                        <FaRegCalendarAlt className="menu-icon" />
                        <span className="menu-text">{showCreateEvent ? 'Create Event' : 'Create Event'}</span>
                    </FabMenuItem>
                    <FabMenuItem className={showTraffic ? 'active' : ''} onClick={handleTrafficToggle}>
                        <MdTraffic className="menu-icon" />
                        <span className="menu-text">{showTraffic ? 'Hide Traffic' : 'Show Traffic'}</span>
                    </FabMenuItem>

                    <FabMenuItem className={showTransit ? 'active' : ''} onClick={handleTransitToggle}>
                        <MdDirectionsBus className="menu-icon" />
                        <span className="menu-text">{showTransit ? 'Hide Transit' : 'Show Transit'}</span>
                    </FabMenuItem>

                    <FabMenuItem className={showEventRoutes ? 'active' : ''} onClick={handleEventRoutesToggle}>
                        <FaRoute className="menu-icon" />
                        <span className="menu-text">{showEventRoutes ? 'Hide Routes' : 'Show Routes'}</span>
                    </FabMenuItem>
                    <FabMenuItem className={showBobChat ? 'active' : ''} onClick={handleToggleBobChat}>
                        <FaRobot className="menu-icon" />
                        <span className="menu-text">{showBobChat ? 'Hide Bob Chat' : 'Show Bob Chat'}</span>
                    </FabMenuItem>
                </FabMenu>

                <StyledCreateChannelToggle
                    className={menuOpen ? 'active' : ''}
                    onClick={toggleMenu}
                    title={menuOpen ? 'Close Menu' : 'Map Options'}
                >
                    <span className={`${menuOpen ? 'rotate' : ''}`}>
                        {menuOpen ? (
                            <MdClose color="white" fontSize={24} />
                        ) : (
                            <BsFillPlusSquareFill color="white" fontSize={24} />
                        )}
                    </span>
                </StyledCreateChannelToggle>
            </FabMenuContainer>
        </>
    );
}

const CreateChannelToggle = (props) => (
    <ComponentErrorBoundary componentErrorMessage={props?.componentErrorMessage}>
        <Component {...props} />
    </ComponentErrorBoundary>
);

export default CreateChannelToggle;
